export default __webpack_public_path__ + "static/media/step3.bc184f53.png";